import type { Enums, Tables } from "@/types/database.types";

export type TaxonomyItem = Tables<"taxonomy">;
export type TaxonomyCategory = Enums<"taxonomy_category_enum">;

export type ArtForm = TaxonomyItem;
export type CulturalArea = TaxonomyItem;
export type ArtisticPeriod = TaxonomyItem;
export type ExhibitionType = TaxonomyItem;

export type TaxonomyData = {
  artForms: ArtForm[];
  culturalAreas: CulturalArea[];
  artisticPeriods: ArtisticPeriod[];
  exhibitionTypes: ExhibitionType[];
};

export type EntityTaxonomySelection = {
  artFormIds: string[];
  artisticPeriodIds: string[];
  culturalAreaIds: string[];
  exhibitionTypeIds: string[];
};

function sameIdSet(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((id, index) => id === sortedB[index]);
}

export function isSameTaxonomySelection(
  a: EntityTaxonomySelection,
  b: EntityTaxonomySelection,
): boolean {
  return (
    sameIdSet(a.artFormIds, b.artFormIds) &&
    sameIdSet(a.artisticPeriodIds, b.artisticPeriodIds) &&
    sameIdSet(a.culturalAreaIds, b.culturalAreaIds) &&
    sameIdSet(a.exhibitionTypeIds, b.exhibitionTypeIds)
  );
}

export function buildTaxonomyFormData(
  entityId: string,
  selection: EntityTaxonomySelection,
): FormData {
  const formData = new FormData();
  formData.set("id", entityId);
  for (const id of selection.artFormIds) formData.append("art_form_ids", id);
  for (const id of selection.artisticPeriodIds) {
    formData.append("artistic_period_ids", id);
  }
  for (const id of selection.culturalAreaIds) {
    formData.append("cultural_area_ids", id);
  }
  for (const id of selection.exhibitionTypeIds) {
    formData.append("exhibition_type_ids", id);
  }
  return formData;
}
